export enum AccountNiche {
  OTHER = 'other',
  HEALTH = 'fitness_health_wellness',
  MARKETING = 'marketing',
  EDUCATION = 'education',
  FAMILY = 'family_parenting',
  FINANCE = 'finance_investing',
  FASHION = 'fashion',
  BEAUTY = 'beauty',
  ENTERTAINMENT = 'entertainment',
  FOOD = 'food_drink',
  HOME = 'home_garden',
  REAL_ESTATE = 'real_estate',
  RELIGION = 'religion_spirituality',
  SOCIAL_IMPACT = 'social_impact_activism_advocacy',
  TECHNOLOGY = 'technology',
  TRAVEL = 'travel',
  VISUAL_ARTS = 'visual_arts',
}
